var map = {
	"./uplanner_en.json": 126,
	"./uplanner_es.json": 127,
	"./uplanner_por.json": 128
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 129;



//////////////////
// WEBPACK FOOTER
// ./src/lang ^\.\/uplanner_.*\.json$
// module id = 129
// module chunks = 0